/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OccurrenceWindow
 */
export interface OccurrenceWindow {
    /**
     * 0-indexed, as the period math counts.
     * @type {number}
     * @memberof OccurrenceWindow
     */
    periodIndex: number;
    /**
     * 1-indexed. This is the value the join endpoint takes to enter this specific occurrence.
     * @type {number}
     * @memberof OccurrenceWindow
     */
    periodNumber: number;
    /**
     * Occurrence start, unix ms.
     * @type {number}
     * @memberof OccurrenceWindow
     */
    startAt: number;
    /**
     * Occurrence end (exclusive), unix ms.
     * @type {number}
     * @memberof OccurrenceWindow
     */
    endAt: number;
}

/**
 * Check if a given object implements the OccurrenceWindow interface.
 */
export function instanceOfOccurrenceWindow(value: object): value is OccurrenceWindow {
    if (!('periodIndex' in value) || value['periodIndex'] === undefined) return false;
    if (!('periodNumber' in value) || value['periodNumber'] === undefined) return false;
    if (!('startAt' in value) || value['startAt'] === undefined) return false;
    if (!('endAt' in value) || value['endAt'] === undefined) return false;
    return true;
}

export function OccurrenceWindowFromJSON(json: any): OccurrenceWindow {
    return OccurrenceWindowFromJSONTyped(json, false);
}

export function OccurrenceWindowFromJSONTyped(json: any, ignoreDiscriminator: boolean): OccurrenceWindow {
    if (json == null) {
        return json;
    }
    return {
        
        'periodIndex': json['periodIndex'],
        'periodNumber': json['periodNumber'],
        'startAt': json['startAt'],
        'endAt': json['endAt'],
    };
}

export function OccurrenceWindowToJSON(json: any): OccurrenceWindow {
    return OccurrenceWindowToJSONTyped(json, false);
}

export function OccurrenceWindowToJSONTyped(value?: OccurrenceWindow | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'periodIndex': value['periodIndex'],
        'periodNumber': value['periodNumber'],
        'startAt': value['startAt'],
        'endAt': value['endAt'],
    };
}

